// Création de l'objet à envoyer au back
const formaterFichierCarteCollectionneur = async (dataForm) => {
    return dataForm.carteCollectionneur ? dataForm.carteCollectionneur[0].getFileToSend() : null;
};

export default formaterFichierCarteCollectionneur;
